/* eslint-disable max-len */
import { LitElement, html, css } from 'lit';

export class GridFrame extends LitElement {
	static styles = css`
        :host {
            position: relative;
            display: grid;
            width: auto;
            margin: var(--spacing-xl) 0;
            row-gap: var(--spacing-xl);
            grid-gap: var(--spacing-xl);
            grid-template-columns: repeat(auto-fill, minmax(var(--vertical-card-width), 1fr));
        }
	`;

	render() {
		return html`
			<slot></slot>  <!-- Slot for child elements -->
		`;
	}
}

customElements.define('studio-gallery-grid-frame', GridFrame);
